"use strict";

var LoggerInstance = require("js-logger").get("SmartyStreetsAutocomplete");

var AccountFormHelper = require("./AccountFormHelper");

var SmartyStreetsApi = require("../api/SmartyStreetsApi");

var Constants = require("../designer/Constants");

var smartyAutocompleteSelector = ".smarty-autocomplete";
var smartySuggestionWrapperSelector = ".smarty-suggestions";
var smartySuggestionSelector = ".smarty-suggestion";
var activeSelector = ".active";
var smartyActiveSuggestionSelector = `${smartySuggestionSelector}${activeSelector}`;

var activeClass = "active";

var cityAttribute = "data-city";
var entriesAttribute = "data-entries";
var secondaryAttribute = "data-secondary";
var stateAttribute = "data-state";
var streetAttribute = "data-street";
var postalCodeAttribute = "data-postalcode";

var SmartyStreetsAutocomplete = class {
	constructor(options) {
		if (!options || !options.addressFormSelector || !options.stateInputSelectSelector || !options.cityInputSelector || !options.address1InputSelector) {
			LoggerInstance.error("Initialize: options not correct.", options);
		}

		if (!$(options.addressFormSelector).length) {
			//The addressForm did not exist, do short-circuit
			return;
		}

		this.addressVerifiedAttribute = Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED;

		this.addressFormSelector = options.addressFormSelector;
		this.address1InputSelector = options.address1InputSelector;
		this.cityInputSelector = options.cityInputSelector;
		this.countryInputSelector = options.countryInputSelector;
		this.postalCodeInputSelector = options.postalCodeInputSelector;
		this.stateInputSelectSelector = options.stateInputSelectSelector;

		this.autocompleteHtml = options.autocompleteHtml;

		$(options.addressFormSelector).attr("autocomplete", "off");
		var $address1Input = $(this.address1InputSelector);
		$address1Input.attr("autocomplete", "off");

		$address1Input.off("keydown.smartyStreetsAutocomplete");
		$address1Input.on("keydown.smartyStreetsAutocomplete", (event) => {
			switch (event.which) {
				case Constants.KEYS.ARROW_DOWN:
					this.downArrowPressed(event);
					break;
				case Constants.KEYS.ARROW_UP:
					this.upArrowPressed(event);
					break;
				case Constants.KEYS.ENTER:
					this.enterKeyPressedOrMouseClicked(event);
					break;
				case Constants.KEYS.ESCAPE:
					this.removeAutocomplete();
					break;
				default:
					break;
			}
		});
		$address1Input.off("keyup.smartyStreetsAutocomplete");
		$address1Input.on("keyup.smartyStreetsAutocomplete", () => {
			this.addressChanged({ manual: true });
		});

		$address1Input.off("blur.smartyStreetsAutocomplete");
		$address1Input.on("blur.smartyStreetsAutocomplete", () => {
			this.removeAutocomplete();
		});
	}

	removeAutocomplete() {
		$(smartyAutocompleteSelector).remove();
	}

	addressChanged(options) {
		options = options || {};

		if (!options.manual) {
			return;
		}

		var $addressLine1 = $(this.address1InputSelector);
		var addressText = $addressLine1.val();

		var country = this._getSelectedCountry();

		if ((addressText && addressText !== this.lastAddress || !!options.selected) && (!country || country === Constants.COUNTRIES.US || country === Constants.COUNTRIES.USA)) {
			LoggerInstance.debug(`Address Changed: ${addressText}`);
			//Aborting the previous call
			if (this.latestAutocompleteRequest && typeof this.latestAutocompleteRequest.abort === "function") {
				this.latestAutocompleteRequest.abort();
			}

			var selected = options.selected || "";

			this.latestAutocompleteRequest = SmartyStreetsApi.autoCompleteAddress({ singleLineAddress: addressText, selected: selected }).done((data, textStatus, jqXHR) => {
				var $suggestionHtml = $(this.autocompleteHtml);

				var bold = "<span class='matched'></span>";
				var addressSpan = "<span></span>";

				if (data) {
					if (data.suggestions && data.suggestions.length > 0) {
						var firstSuggestion = true;
						$suggestionHtml.find('.smarty-no-suggestions').remove();
						data.suggestions.forEach(suggestion => {
							if (!suggestion.street_line) {
								return;
							}

							var $singleSuggestion;
							if (firstSuggestion) {
								$singleSuggestion = $suggestionHtml.find(".smarty-suggestion");
							} else {
								$singleSuggestion = $suggestionHtml.find(".smarty-suggestion").first().clone();
							}

							var $addressSpanElement = $(addressSpan);

							var secondaryText = suggestion.entries == 1 ? suggestion.secondary : '';
							var multipleEntriesText = suggestion.entries > 1 ? `(${suggestion.entries} more entries)` : '';
							var streetLineText = suggestion.street_line;

							if (addressText.indexOf(`${streetLineText} ${secondaryText}`) === 0) {
								streetLineText = streetLineText + addressText.replace(streetLineText, "");
								secondaryText = '';
							}

							var suggestionDisplayText = `${streetLineText} ${secondaryText} ${suggestion.city}, ${suggestion.state} ${multipleEntriesText}`;

							if (suggestionDisplayText.indexOf(addressText) === 0) {
								var rest = suggestionDisplayText.replace(addressText, "");

								var $boldElement = $(bold);
								$boldElement.text(addressText);
								$addressSpanElement.text(rest);

								$singleSuggestion.empty().append($boldElement).append($addressSpanElement);
							} else {
								$addressSpanElement.text(suggestionDisplayText);
								$singleSuggestion.empty().append($addressSpanElement);
							}

							$singleSuggestion
								.attr(cityAttribute, suggestion.city)
								.attr(entriesAttribute, suggestion.entries)
								.attr(secondaryAttribute, suggestion.secondary)
								.attr(stateAttribute, suggestion.state)
								.attr(streetAttribute, suggestion.street_line)
								.attr(postalCodeAttribute, suggestion.zipcode);

							if (firstSuggestion) {
								firstSuggestion = false;
							} else {
								$suggestionHtml.find(".smarty-suggestion").last().after($singleSuggestion);
							}
						});
					} else {
						$suggestionHtml.find(".smarty-suggestion").remove();
					}
				} else {
					return;
				}

				//Setting the correct width, based upon address 1 field
				$suggestionHtml.find(smartySuggestionWrapperSelector).css("maxWidth", (Math.max($addressLine1.outerWidth(), 250)));

				if ($(smartyAutocompleteSelector).length) {
					$(smartyAutocompleteSelector).replaceWith($suggestionHtml);
				} else {
					$("body").append($suggestionHtml);
				}

				this._addEventListeners($(smartyAutocompleteSelector));

				var position = $addressLine1.offset();
				var topPixelText = (position.top + $addressLine1.outerHeight(false)) + "px";

				$(smartyAutocompleteSelector).css({
					left: position.left + "px",
					top: topPixelText,
					maxHeight: topPixelText,
					overflow: "hidden auto"
				});
			}).fail((jqXHR, textStatus, errorThrown) => {
				if (textStatus !== "abort") {
					LoggerInstance.error("Auto-complete call failed: ", jqXHR, textStatus, errorThrown);
				}
			});
		} else if (!addressText) {
			this.removeAutocomplete();
		}

		this.lastAddress = addressText;
	}

	_addEventListeners($suggestionElement) {
		if (!$suggestionElement || !$suggestionElement.length) {
			return;
		}

		$suggestionElement.find(smartySuggestionSelector).hover(function() {
			$(this).addClass(activeClass);
		}, function() {
			$(this).removeClass(activeClass);
		});

		$suggestionElement.mousedown((event) => {
			this.enterKeyPressedOrMouseClicked(event);
		});
	}

	_getSelectedCountry() {
		return $(this.countryInputSelector).val() || window.AccountStore.getDefaultCountry();
	}

	downArrowPressed(event) {
		var $autoComplete = $(smartyAutocompleteSelector);
		if ($autoComplete.length) {
			var $activeElement = $autoComplete.find(smartyActiveSuggestionSelector);
			if ($activeElement.length) {
				var $nextElement = $activeElement.next();
				if (!$nextElement.length) {
					$nextElement = $autoComplete.find(`${smartySuggestionSelector}`).first();
				}

				if ($nextElement.length) {
					$activeElement.removeClass(activeClass);
					$nextElement.addClass(activeClass);
				}
			} else {
				$autoComplete.find(`${smartySuggestionSelector}`).first().addClass(activeClass);
			}
			event.preventDefault();
		}
	}

	enterKeyPressedOrMouseClicked(event) {
		var $active = $(`${smartyAutocompleteSelector} ${smartyActiveSuggestionSelector}`);
		if (!$active.length) {
			return;
		}

		if (!event || (event.type === "mousedown" && event.which !== 1) /*left click*/) {
			//We do not handle middle and right mouse click on autocomplete
			return;
		}

		event.preventDefault();

		var city = $active.attr(cityAttribute) || "";
		var entries = $active.attr(entriesAttribute) || "0";
		var secondary = $active.attr(secondaryAttribute) || "";
		var state = $active.attr(stateAttribute) || "";
		var street = $active.attr(streetAttribute) || "";
		var zipcode = $active.attr(postalCodeAttribute) || "";

		// Setting address line 1
		var $address1Input = $(this.address1InputSelector);
		$address1Input.val(`${street} ${secondary}`);

		// Setting the city
		$(this.cityInputSelector).val(city);

		//Setting the state react input value
		var formId = AccountFormHelper.getParentFormId($(this.stateInputSelectSelector)[0]);
		window.AccountActions.setSelectedState(formId, state);

		//Setting the zip code
		$(this.postalCodeInputSelector).val(zipcode);

		// If the active suggestion has multiple entries we need to re-call the autocomplete process
		// passing the properly formatted address parts to the 'selected' option.
		if (entries > 1) {
			// This exact string format is required for SmartyStreet to return the additional addresses for an address that has multiple secondary addresses.
			var smartyStreetsFormattedSelectedText = `${street} ${secondary} (${entries}) ${city} ${state} ${zipcode}`;

			this.latestAutocompleteRequest = null;

			this.addressChanged({
				manual: true,
				selected: smartyStreetsFormattedSelectedText
			})

			return;
		}

		// Add the verified address attribute if we've selected a smarty streets selected address
		$(this.addressFormSelector).attr(this.addressVerifiedAttribute, "true");

		$address1Input.trigger("change"); //Triggering a change so that shipping and tax can recalculate if necessary
		$address1Input.blur();
	}

	upArrowPressed(event) {
		var $autoComplete = $(smartyAutocompleteSelector);
		if ($autoComplete.length) {
			var $activeElement = $autoComplete.find(smartyActiveSuggestionSelector);
			if ($activeElement.length) {
				var $prevElement = $activeElement.prev();
				if (!$prevElement.length) {
					var $prevElement = $autoComplete.find(`${smartySuggestionSelector}`).last();
				}

				if ($prevElement.length) {
					$activeElement.removeClass(activeClass);
					$prevElement.addClass(activeClass);
				}
			} else {
				$autoComplete.find(`${smartySuggestionSelector}`).first().addClass(activeClass);
			}
			event.preventDefault();
		}
	}
};

module.exports = SmartyStreetsAutocomplete;
